var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('animate-number',{attrs:{"mode":"auto","from":_vm.from,"to":_vm.to,"duration":4000,"easing":"easeOutQuad"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c63ef92","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnimateNumber.vue
// module id = 1549
// module chunks = 27